import React, { useState, useContext, useEffect, Fragment } from "react";
import "./Profile.css";
import { useNavigate } from "react-router-dom";
import avatarImage from "../../../assets/images/techapp/avatar-min.png";
import { Popover, Button, Collapse, Modal, Input, Tag } from "antd";
import {
  EnvironmentOutlined,
  InboxOutlined,
  BookOutlined,
} from "@ant-design/icons";
import { IoIosHelpCircleOutline } from "react-icons/io";
import Colors from "../../../Helper/Colors";
import version from "../../../Constant/version.json";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import { techappContext } from "../../../Api/techappReq";
import useUser from "../../../hooks/useUser";
import FormatHelper from "../../../Helper/FormatHelper";
import lang from "../lang/lang.json";
import { GrTransaction } from "react-icons/gr";
import Layout from "../../../layout";
import { FaRegBell } from "react-icons/fa";
import { HiOutlineDatabase } from "react-icons/hi";

const { Panel } = Collapse;
const { TextArea } = Input;

const Profile = () => {
  const navigate = useNavigate();
  const { handleLogout, available, profile } = useContext(techappContext);

  const { getUserSkills, userSkills } = useUser();

  const [isAcceptVisible, setIsAcceptVisible] = useState(false);
  const [isResetVisible, setIsResetVisible] = useState(false);
  const [desc, setDesc] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [callModal, setCallModal] = useState(false);
  const profileData = useSelector((state) => state.TechAppReducer.profileData);
  const hints = useSelector((state) => state.TechAppReducer.hints);

  const genExtra = () => (
    <EnvironmentOutlined
      style={{ marginLeft: "10px" }}
      onClick={(event) => {
        event.stopPropagation();
      }}
    />
  );

  const genExtra2 = () => (
    <InboxOutlined
      style={{ marginLeft: "10px" }}
      onClick={(event) => {
        event.stopPropagation();
      }}
    />
  );

  const genExtra3 = () => (
    <BookOutlined
      style={{ marginLeft: "10px" }}
      onClick={(event) => {
        event.stopPropagation();
      }}
    />
  );

  const noAccept = () => {
    if (desc.length === 0) {
      toast.warning(lang.PLEASE_ENTER_DESCRIPTION);
    } else if (desc.length < 6) {
      toast.warning(lang.DESCRIPTION_MUST_BE_AT_LEAST_6_CHARACTAR);
    } else {
      setIsAcceptVisible(false);
      available(0, desc);
      setDesc("");
    }
  };

  const confirmLogout = () => {
    setIsOpen(false);
    handleLogout();
  };

  useEffect(() => {
    profile();
    getUserSkills();
  }, []);

  return (
    <Layout>
      <>
        {profileData && (
          <div className="tech-app-profile">
            {/* user infos */}
            <div
              style={{ justifyContent: "center", padding: "10px" }}
              className="tech-app-header"
            >
              <span>
                {profileData?.first_name && profileData.first_name}{" "}
                {profileData?.last_name &&
                  profileData.last_name.substring(0, 10)}
              </span>
              <div className="tech-app-profile-avatar-wrapper">
                {profileData.avatar.length === 0 ||
                profileData.avatar === null ? (
                  <img
                    style={{ borderRadius: "50%" }}
                    className="tech-app-profile-avatar"
                    src={avatarImage}
                    alt="user avatar"
                  />
                ) : (
                  <img
                    style={{ borderRadius: "50%" }}
                    className="tech-app-profile-avatar"
                    src={profileData.avatar}
                    alt="user avatar"
                  />
                )}
              </div>
              <span style={{ direction: "ltr" }}>
                {FormatHelper.toPersianString(profileData?.mobile)}
              </span>
            </div>
            {/* profile body */}
            <div className="tech-app-profile-body">
              {/* buttons section */}
              <div className="tech-app-profile-body-btns">
                {/* stat button */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  <Button
                    onClick={() => {
                      navigate("/techapp/transactions");
                    }}
                    style={{ backgroundColor: Colors.warning }}
                    id="profile_transactions_page_button"
                  >
                    <GrTransaction style={{ marginLeft: 8 }} />
                    تراکنش ها
                  </Button>
                  {hints.map((hint, index) => {
                    if (
                      hint.section === "transactions_page" &&
                      hint.type === "text" &&
                      hint.body.length > 0
                    ) {
                      return (
                        <Popover
                          key={index}
                          trigger={"click"}
                          placement="bottom"
                          title={
                            <div style={{ textAlign: "right" }}>راهنما</div>
                          }
                          content={
                            <div style={{ textAlign: "right", maxWidth: 270 }}>
                              {hint.body}
                            </div>
                          }
                        >
                          <div
                            style={{ marginRight: 8 }}
                            className="help_button"
                          >
                            <IoIosHelpCircleOutline
                              style={{ color: "#1e5279", fontSize: 22 }}
                            />
                          </div>
                        </Popover>
                      );
                    } else if (
                      hint.section === "transactions_page" &&
                      hint.type === "link" &&
                      hint.body.length > 0
                    ) {
                      return (
                        <div
                          key={index}
                          style={{ marginRight: 8 }}
                          onClick={() => window.open(hint.body, "_blank")}
                          className="help_button"
                        >
                          <IoIosHelpCircleOutline
                            style={{ color: "#1e5279", fontSize: 22 }}
                          />
                        </div>
                      );
                    }

                    return '';
                  })}
                </div>
                {/* exit and call button */}
                <div style={{ display: "flex" }}>
                  <div>
                    <Button
                      onClick={() => {
                        if (!localStorage.getItem("auth_from_admin")) {
                          setCallModal(true);
                        }
                      }}
                      style={{ backgroundColor: Colors.success }}
                    >
                      {lang.CONTACT_SUPPORT}
                    </Button>
                    {hints.map((hint, index) => {
                      if (
                        hint.section === "profile_contact_support" &&
                        hint.type === "text" &&
                        hint.body.length > 0
                      ) {
                        return (
                          <Popover
                            key={index}
                            trigger={"click"}
                            placement="bottom"
                            title={
                              <div style={{ textAlign: "right" }}>راهنما</div>
                            }
                            content={
                              <div
                                style={{ textAlign: "right", maxWidth: 270 }}
                              >
                                {hint.body}
                              </div>
                            }
                          >
                            <div
                              style={{ marginRight: 8 }}
                              className="help_button"
                            >
                              <IoIosHelpCircleOutline
                                style={{ color: "#1e5279", fontSize: 22 }}
                              />
                            </div>
                          </Popover>
                        );
                      } else if (
                        hint.section === "profile_contact_support" &&
                        hint.type === "link" &&
                        hint.body.length > 0
                      ) {
                        return (
                          <div
                            key={index}
                            style={{ marginRight: 8 }}
                            onClick={() => window.open(hint.body, "_blank")}
                            className="help_button"
                          >
                            <IoIosHelpCircleOutline
                              style={{ color: "#1e5279", fontSize: 22 }}
                            />
                          </div>
                        );
                      }

                      return '';
                    })}
                  </div>

                  <Button
                    onClick={() => setIsOpen(true)}
                    style={{ backgroundColor: Colors.danger }}
                  >
                    {lang.LOGGOUT}
                  </Button>
                </div>
              </div>
              {/* available section */}
              <div
                className="teach-app-profile-cards"
                style={{ position: "relative" }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <FaRegBell />
                  <span className="tech-app-profile-cards-title">
                    {lang.AVAILABALITY_STATUS}
                  </span>
                </div>
                <div className="techapp-available-btns">
                  <Button
                    className={
                      profileData.available === 1
                        ? "techapp-profile-user-available-btn btn-text-white"
                        : ""
                    }
                    onClick={() => {
                      if (!localStorage.getItem("auth_from_admin")) {
                        available(1);
                      } else {
                        toast.error(
                          "شما از پنل ادمین وارد شده اید و دسترسی ندارید."
                        );
                      }
                    }}
                    style={
                      localStorage.getItem("auth_from_admin")
                        ? { filter: "blur(1px)", cursor: "not-allowed" }
                        : {}
                    }
                  >
                    {lang.IM_AVAILABLE}
                  </Button>
                  <Button
                    className={
                      profileData.available === 0
                        ? "techapp-profile-user-available-btn btn-text-white"
                        : ""
                    }
                    style={
                      localStorage.getItem("auth_from_admin")
                        ? {
                            filter: "blur(1px)",
                            cursor: "not-allowed",
                            color: "black",
                          }
                        : { color: "black" }
                    }
                    onClick={() => {
                      if (!localStorage.getItem("auth_from_admin")) {
                        setIsAcceptVisible(true);
                      } else {
                        toast.error(
                          "شما از پنل ادمین وارد شده اید و دسترسی ندارید."
                        );
                      }
                    }}
                  >
                    {lang.IM_NOT_AVAILABLE}
                  </Button>
                </div>
                <Modal
                  ariaHideApp={false}
                  open={isAcceptVisible}
                  onOk={() => setIsAcceptVisible(false)}
                  onCancel={() => setIsAcceptVisible(false)}
                  style={{ borderRadius: "6px", textAlign: "center" }}
                  title={lang.WHY_YOU_ARE_NOT_AVAILABLE}
                  footer={[
                    <>
                      <Button
                        onClick={() => setIsAcceptVisible(false)}
                        className="tech-app-reset-data-btns btn-text-black"
                        style={{
                          backgroundColor: "rgba(199, 199, 199, 0.322)",
                          color: "black",
                        }}
                      >
                        {lang.CANCEL}
                      </Button>
                      <Button
                        onClick={noAccept}
                        className="tech-app-reset-data-btns btn-text-white"
                        style={{
                          backgroundColor: Colors.royalBlue,
                          color: "white",
                        }}
                        id="profile_unavailable_submit_button"
                      >
                        {lang.SUBMIT}
                      </Button>
                    </>,
                  ]}
                >
                  <TextArea
                    onChange={(e) => setDesc(e.target.value)}
                    value={desc}
                    style={{
                      maxHeight: "120px",
                      textAlign: "right",
                      borderRadius: "6px",
                      paddingTop: "10px",
                    }}
                    autoSize
                    id="profile_unavailable_description_input"
                    placeholder={lang.DESCRIPTION}
                  />
                </Modal>
                {hints.map((hint, index) => {
                  if (
                    hint.section === "profile_availablity" &&
                    hint.type === "text" &&
                    hint.body.length > 0
                  ) {
                    return (
                      <Popover
                        key={index}
                        trigger={"click"}
                        placement="bottom"
                        title={<div style={{ textAlign: "right" }}>راهنما</div>}
                        content={
                          <div style={{ textAlign: "right", maxWidth: 270 }}>
                            {hint.body}
                          </div>
                        }
                      >
                        <div
                          style={{ marginRight: 8 }}
                          className="help_button"
                          id="profile_available_help"
                        >
                          <IoIosHelpCircleOutline
                            style={{ color: "#1e5279", fontSize: 22 }}
                          />
                        </div>
                      </Popover>
                    );
                  } else if (
                    hint.section === "profile_availablity" &&
                    hint.type === "link" &&
                    hint.body.length > 0
                  ) {
                    return (
                      <div
                        key={index}
                        style={{ marginRight: 8 }}
                        onClick={() => window.open(hint.body, "_blank")}
                        className="help_button"
                      >
                        <IoIosHelpCircleOutline
                          style={{ color: "#1e5279", fontSize: 22 }}
                        />
                      </div>
                    );
                  }

                  return '';
                })}
              </div>
              {/* educational content */}
              <Collapse
                style={{ padding: "0 10px" }}
                className="teach-app-profile-cards"
                defaultActiveKey={"1"}
              >
                <Panel
                  extra={genExtra3()}
                  header={
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span>محتوای آموزشی</span>
                      {hints.map((hint, index) => {
                        if (
                          hint.section === "profile_educational_content" &&
                          hint.type === "text" &&
                          hint.body.length > 0
                        ) {
                          return (
                            <Popover
                              key={index}
                              trigger={"click"}
                              placement="bottom"
                              title={
                                <div style={{ textAlign: "right" }}>راهنما</div>
                              }
                              content={
                                <div
                                  style={{ textAlign: "right", maxWidth: 270 }}
                                >
                                  {hint.body}
                                </div>
                              }
                            >
                              <div
                                style={{ marginRight: 8 }}
                                className="help_button"
                              >
                                <IoIosHelpCircleOutline
                                  style={{ color: "#1e5279", fontSize: 22 }}
                                />
                              </div>
                            </Popover>
                          );
                        } else if (
                          hint.section === "profile_educational_content" &&
                          hint.type === "link" &&
                          hint.body.length > 0
                        ) {
                          return (
                            <div
                              key={index}
                              style={{ marginRight: 8 }}
                              onClick={() => window.open(hint.body, "_blank")}
                              className="help_button"
                            >
                              <IoIosHelpCircleOutline
                                style={{ color: "#1e5279", fontSize: 22 }}
                              />
                            </div>
                          );
                        }

                        return '';
                      })}
                    </div>
                  }
                  key="1"
                >
                  <div className="tech-app-profile-educational-section">
                    <a
                      href="https://karabama.com/internal_post/educational-videos/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      ویدئوهای آموزشی
                    </a>
                    <a
                      href="https://karabama.com/internal_post/educational-contents/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      آموزش تکمیلی
                    </a>
                  </div>
                </Panel>
              </Collapse>
              {/* user info card */}
              <div
                id="profile_balance_card"
                className="teach-app-profile-cards"
              >
                {/* balance */}
                <div style={{ marginLeft: 16 }}>
                  <HiOutlineDatabase />
                  <span className="tech-app-profile-cards-title">
                    {lang.BALANCE} :
                  </span>
                  <span style={{ marginRight: "5px" }}>
                    <span
                      className="tech-app-profile-charge"
                      style={
                        profileData.balance > 0
                          ? { color: Colors.success }
                          : { color: Colors.danger }
                      }
                    >
                      {profileData.balance !== null &&
                        FormatHelper.toPersianString(
                          Math.abs(profileData.balance).toLocaleString()
                        )}
                    </span>
                    {lang.TOMAN}
                  </span>
                </div>
                {/* saved balance */}
                <div>
                  <HiOutlineDatabase />
                  <span className="tech-app-profile-cards-title">
                    {lang.SAVED_BALANCE} :
                  </span>
                  <span style={{ marginRight: "5px" }}>
                    <span
                      className="tech-app-profile-charge"
                      style={
                        profileData.saved_balance > 0
                          ? { color: Colors.success }
                          : { color: Colors.danger }
                      }
                    >
                      {profileData.saved_balance !== null &&
                        FormatHelper.toPersianString(
                          profileData.saved_balance.toLocaleString()
                        )}
                    </span>
                    {lang.TOMAN}
                  </span>
                </div>
              </div>
              {/* user support area */}
              <Collapse
                style={{ padding: "0 10px" }}
                className="teach-app-profile-cards"
              >
                <Panel
                  extra={genExtra()}
                  header={
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span>{lang.SUPPORT_AREAS}</span>
                      {hints.map((hint, index) => {
                        if (
                          hint.section === "profile_user_support_area" &&
                          hint.type === "text" &&
                          hint.body.length > 0
                        ) {
                          return (
                            <Popover
                              key={index}
                              trigger={"click"}
                              placement="bottom"
                              title={
                                <div style={{ textAlign: "right" }}>راهنما</div>
                              }
                              content={
                                <div
                                  style={{ textAlign: "right", maxWidth: 270 }}
                                >
                                  {hint.body}
                                </div>
                              }
                            >
                              <div
                                style={{ marginRight: 8 }}
                                className="help_button"
                              >
                                <IoIosHelpCircleOutline
                                  style={{ color: "#1e5279", fontSize: 22 }}
                                />
                              </div>
                            </Popover>
                          );
                        } else if (
                          hint.section === "profile_user_support_area" &&
                          hint.type === "link" &&
                          hint.body.length > 0
                        ) {
                          return (
                            <div
                              key={index}
                              style={{ marginRight: 8 }}
                              onClick={() => window.open(hint.body, "_blank")}
                              className="help_button"
                            >
                              <IoIosHelpCircleOutline
                                style={{ color: "#1e5279", fontSize: 22 }}
                              />
                            </div>
                          );
                        }

                        return '';
                      })}
                    </div>
                  }
                  key="1"
                >
                  <div style={{ paddingTop: "10px" }}>
                    {profileData.supportings.data.map((area, index) => (
                      <Tag
                        style={{
                          marginBottom: "15px",
                          padding: "4px",
                          borderRadius: "6px",
                        }}
                        key={index}
                      >
                        {area.title}
                      </Tag>
                    ))}
                  </div>
                </Panel>
              </Collapse>
              {/* user skills */}
              <Collapse
                style={{ padding: "0 10px" }}
                className="teach-app-profile-cards"
              >
                <Panel
                  extra={genExtra2()}
                  header={
                    <div style={{ display: "flex", alignItems: "center" }}>
                      <span>{lang.MY_SKILLS}</span>
                      {hints.map((hint, index) => {
                        if (
                          hint.section === "profile_user_skills" &&
                          hint.type === "text" &&
                          hint.body.length > 0
                        ) {
                          return (
                            <Popover
                              key={index}
                              trigger={"click"}
                              placement="bottom"
                              title={
                                <div style={{ textAlign: "right" }}>راهنما</div>
                              }
                              content={
                                <div
                                  style={{ textAlign: "right", maxWidth: 270 }}
                                >
                                  {hint.body}
                                </div>
                              }
                            >
                              <div
                                style={{ marginRight: 8 }}
                                className="help_button"
                              >
                                <IoIosHelpCircleOutline
                                  style={{ color: "#1e5279", fontSize: 22 }}
                                />
                              </div>
                            </Popover>
                          );
                        } else if (
                          hint.section === "profile_user_skills" &&
                          hint.type === "link" &&
                          hint.body.length > 0
                        ) {
                          return (
                            <div
                              key={index}
                              style={{ marginRight: 8 }}
                              onClick={() => window.open(hint.body, "_blank")}
                              className="help_button"
                            >
                              <IoIosHelpCircleOutline
                                style={{ color: "#1e5279", fontSize: 22 }}
                              />
                            </div>
                          );
                        }

                        return '';
                      })}
                    </div>
                  }
                  key="1"
                >
                  <div style={{ paddingTop: "10px" }}>
                    {userSkills.map((skill, index) => {
                      return (
                        <Collapse
                          style={{
                            padding: "0 10px",
                            boxShadow: "none",
                            marginBottom: 10,
                          }}
                          key={index}
                          defaultActiveKey={[index]}
                          className="teach-app-profile-cards"
                        >
                          <Panel
                            key={index}
                            extra={<span>--</span>}
                            header={skill.skill}
                          >
                            {skill?.items?.types?.length === 0 &&
                            skill?.items?.brands?.length === 0 &&
                            skill?.items?.problems?.length === 0 ? (
                              <div
                                style={{
                                  padding: "5px 0 10px 0",
                                  color: "rgba(0,0,0,.7)",
                                }}
                              >
                                موردی یافت نشد.
                              </div>
                            ) : (
                              <Fragment>
                                {/* types */}
                                {skill?.items?.types?.length === 0 ? null : (
                                  <div style={{ marginBottom: 5 }}>
                                    <h4 style={{ margin: "0 5px 5px 0" }}>
                                      {lang.DEVICE_FEATURES}
                                    </h4>
                                    {skill?.items?.types?.map((type, i) => (
                                      <Tag
                                        key={i}
                                        style={{
                                          marginBottom: "15px",
                                          padding: "4px",
                                          borderRadius: "6px",
                                        }}
                                      >
                                        {FormatHelper.toPersianString(type)}
                                      </Tag>
                                    ))}
                                  </div>
                                )}
                                {/* brands */}
                                {skill?.items?.brands?.length === 0 ? null : (
                                  <div style={{ marginBottom: 5 }}>
                                    <h4 style={{ margin: "0 5px 5px 0" }}>
                                      {lang.BRANDS}
                                    </h4>

                                    {skill?.items?.brands?.map((brand, i) => (
                                      <Tag
                                        key={i}
                                        style={{
                                          marginBottom: "15px",
                                          padding: "4px",
                                          borderRadius: "6px",
                                        }}
                                      >
                                        {brand}
                                      </Tag>
                                    ))}
                                  </div>
                                )}
                                {/* problems */}
                                {skill?.items?.problems?.length === 0 ? null : (
                                  <div style={{ marginBottom: 5 }}>
                                    <h4 style={{ margin: "0 5px 5px 0" }}>
                                      {lang.PROBLEMS}
                                    </h4>
                                    {skill?.items?.problems?.map(
                                      (problem, i) => (
                                        <Tag
                                          key={i}
                                          style={{
                                            marginBottom: "15px",
                                            padding: "4px",
                                            borderRadius: "6px",
                                          }}
                                        >
                                          {problem}
                                        </Tag>
                                      )
                                    )}
                                  </div>
                                )}
                              </Fragment>
                            )}
                          </Panel>
                        </Collapse>
                      );
                    })}
                  </div>
                </Panel>
              </Collapse>
              {/* app version */}
              <div
                style={{
                  textAlign: "center",
                  padding: "5px 10px",
                  color: "black",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                className="teach-app-profile-cards"
              >
                {lang.VERSION} {FormatHelper.toPersianString(version.version)}
              </div>
              {/* clear data */}
              <div
                onClick={() => setIsResetVisible(true)}
                style={{
                  cursor: "pointer",
                  textAlign: "center",
                  padding: "5px 10px",
                  color: "gray",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                className="teach-app-profile-cards"
              >
                {lang.CLEAR_APP_DATA}
              </div>
              {/* bug report */}
              <div
                onClick={() => {
                  navigate("/techapp/bug-report");
                }}
                style={{
                  textAlign: "center",
                  padding: "5px 10px",
                  color: "black",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                id="profile_bug_report_button"
                className="teach-app-profile-cards"
              >
                {lang.APP_BUG_REPORT}
              </div>
              {/* clear data modal */}
              <Modal
                ariaHideApp={false}
                open={isResetVisible}
                onOk={handleLogout}
                onCancel={() => setIsResetVisible(false)}
                style={{
                  borderRadius: "6px",
                  textAlign: "center",
                }}
                title={lang.ARE_YOU_SURE_YOU_WANT_TO_CLEAR_APP_DATA}
                footer={[
                  <>
                    <Button
                      onClick={() => setIsResetVisible(false)}
                      className="tech-app-reset-data-btns"
                      style={{
                        backgroundColor: "rgba(199, 199, 199, 0.322)",
                        color: "black",
                      }}
                    >
                      {lang.CANCEL}
                    </Button>
                    <Button
                      onClick={handleLogout}
                      className="tech-app-reset-data-btns"
                      style={{
                        backgroundColor: Colors.royalBlue,
                        color: "white",
                      }}
                    >
                      {lang.YES}
                    </Button>
                  </>,
                ]}
              >
                <div style={{ direction: "rtl", margin: "10px 0 15px 0" }}>
                  {lang.CLEAR_APP_DATA_DESCRIPTION}
                </div>
              </Modal>
              {/* logout modal */}
              <Modal
                ariaHideApp={false}
                open={isOpen}
                onOk={confirmLogout}
                onCancel={() => setIsOpen(false)}
                className="techapp-action-cancel-order"
                style={{ borderRadius: "6px", textAlign: "center" }}
                title={lang.DO_YOU_WANT_TO_LOGGOUT}
                footer={[
                  <>
                    <Button
                      onClick={() => setIsOpen(false)}
                      className="tech-app-reset-data-btns btn-text-black"
                      style={{
                        backgroundColor: "rgba(199, 199, 199, 0.322)",
                        color: "black",
                      }}
                    >
                      {lang.CANCEL}
                    </Button>
                    <Button
                      onClick={confirmLogout}
                      className="tech-app-reset-data-btns btn-text-white"
                      style={{ backgroundColor: Colors.danger, color: "white" }}
                    >
                      {lang.YES}
                    </Button>
                  </>,
                ]}
              ></Modal>
              {/* call modal */}
              <Modal
                ariaHideApp={false}
                open={callModal}
                onOk={handleLogout}
                onCancel={() => setCallModal(false)}
                style={{
                  borderRadius: "6px",
                  textAlign: "center",
                }}
                title={lang.WHY_TICKET_IS_BETTER}
                footer={[
                  <>
                    <Button
                      onClick={() => setIsResetVisible(false)}
                      className="tech-app-reset-data-btns"
                      style={{
                        backgroundColor: "rgba(199, 199, 199, 0.322)",
                        color: "black",
                      }}
                    >
                      <a href="tel:02141259360">{lang.CALL}</a>
                    </Button>
                    <Button
                      onClick={() => {
                        navigate("/techapp/create-ticket");
                      }}
                      className="tech-app-reset-data-btns"
                      style={{
                        backgroundColor: Colors.royalBlue,
                        color: "white",
                      }}
                    >
                      {lang.SUBMIT_TICKET}
                    </Button>
                  </>,
                ]}
              >
                <div
                  style={{
                    direction: "rtl",
                    display: "flex",
                    flexDirection: "column",
                    margin: "10px 0 15px 0",
                    alignItems: "flex-start",
                    textAlign: "right",
                  }}
                >
                  <span style={{ marginBottom: "10px" }}>
                    ۱ - {lang.WHY_TICKET_IS_BETTER_REASON_1}
                  </span>
                  <span style={{ marginBottom: "10px" }}>
                    ۲ - {lang.WHY_TICKET_IS_BETTER_REASON_2}
                  </span>
                  <span style={{ marginBottom: "10px" }}>
                    ۳ - {lang.WHY_TICKET_IS_BETTER_REASON_3}
                  </span>
                </div>
              </Modal>
            </div>
          </div>
        )}
      </>
    </Layout>
  );
};
export default Profile;
